import React, { useState } from "react";
import Link from "next/link";
import { observer } from "mobx-react";
import ChevronDown from "assets/icons/chevron-down.svg";
import { useStore } from "store";
import { useUrl } from "helpers/hooks";

import { cn } from "helpers/style";
import styles from "./Accordion.module.scss";

type Props = {
  title: string;
  elements: Array<{ href: string; title: string; local?: boolean }>;
  showWhatAboutOrder: boolean;
};

const Accordion: React.FC<Props> = ({
  title,
  elements,
  showWhatAboutOrder,
}: Props) => {
  const [open, toggle] = useState(false);
  const { getEntityLinkProps, getLinkProps } = useUrl();
  const { user } = useStore();

  const handleAuth = e => user.withAuth({ event: e });

  function collapse() {
    toggle(!open);
  }

  const getCurrentLinkProps = entity => {
    return getEntityLinkProps("navLinks", entity, {
      withRegion: !!entity.regionDependent,
    });
  };

  return (
    <div className={styles.footerAccordion}>
      <span
        className={cn([
          styles.footerAccordionTitle,
          open && styles.footerAccordionTitleOpened,
        ])}
        onClick={collapse}
      >
        {title}

        <ChevronDown />
      </span>
      <div
        className={cn([
          styles.footerAccordionCollapse,
          open && styles.footerAccordionCollapseOpened,
        ])}
      >
        {elements.map((item, idx) => (
          <Link
            key={idx}
            {...getCurrentLinkProps(item)}
            className={styles.footerAccordionLink}
            passHref
          >
            {item.title}
          </Link>
        ))}
        {showWhatAboutOrder && (
          <Link
            key="showWhatAboutOrder"
            href={
              user.isAuth
                ? getLinkProps(
                    `/personal/${user.profile?.id}/history/`,
                    undefined,
                    { withRegion: false, withOrigin: true }
                  ).as
                : "/"
            }
            className={styles.footerAccordionLink}
            onClick={handleAuth}
            passHref
          >
            Что с моим заказом?
          </Link>
        )}
      </div>
    </div>
  );
};

export default observer(Accordion);
